import type { AnswerT } from '../../..';
import type { ResolvedValues } from '../../type/common/types';
import type { TaskQuestionnaireResolver } from '../../type/task-questionnaire';
import { QaCheckError } from '../../utils/error';
import { QaCheckErrorCode } from '../../utils/error';
export const resolveTaskQuestionnaire = (taskResolver: TaskQuestionnaireResolver, taskAnswers: AnswerT): QaCheckError | ResolvedValues<'TASK_QUESTIONNAIRE'> => {
  const resolvedValues = Object.entries(taskResolver.resolve).reduce<{
    [subResolver: string]: string | string[];
  } | QaCheckError>((accumulatedValues, [subAlias, resolver]) => {
    if (accumulatedValues instanceof QaCheckError) {
      return accumulatedValues;
    }
    const questionId = resolver.questionId;
    const questionAnswers = taskAnswers[questionId];
    if (!questionAnswers || questionAnswers.answers.length === 0) {
      return new QaCheckError('Answers missing for provided questionId', QaCheckErrorCode.missingFields);
    }
    const filteredAnswers = questionAnswers.answers.filter(answer => typeof answer === 'string');
    accumulatedValues[subAlias] = filteredAnswers.length === 1 ? filteredAnswers[0] ?? '' : filteredAnswers;
    return accumulatedValues;
  }, {});
  if (resolvedValues instanceof QaCheckError) {
    return resolvedValues;
  }
  return [{
    values: resolvedValues,
    metadata: {
      type: 'TASK_QUESTIONNAIRE',
      id: 'questionnaire'
    }
  }];
};